export default __webpack_public_path__ + "static/TXRoom-5b6c915ba1835c1fbda7a4e8023d6bc1.webp";